
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"#fff","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_160_487)"}},[_c('path',{attrs:{"d":"M15.078 8.984a.781.781 0 100-1.562.781.781 0 000 1.562z"}}),_c('path',{attrs:{"d":"M16.875 1.563h-1.016V.78a.781.781 0 00-1.562 0v.781h-3.555v-.78a.781.781 0 00-1.562 0v.78H5.664v-.78a.781.781 0 10-1.562 0v.78h-.977A3.129 3.129 0 000 4.688v12.188A3.129 3.129 0 003.125 20h5.977a.781.781 0 100-1.563H3.125c-.862 0-1.563-.7-1.563-1.562V4.687c0-.861.701-1.562 1.563-1.562h.977v.781a.781.781 0 101.562 0v-.781H9.18v.781a.781.781 0 101.562 0v-.781h3.555v.781a.781.781 0 101.562 0v-.781h1.016c.862 0 1.563.7 1.563 1.563V9.14a.781.781 0 001.562 0V4.687a3.129 3.129 0 00-3.125-3.125z"}}),_c('path',{attrs:{"d":"M15.273 10.547a4.732 4.732 0 00-4.726 4.726A4.732 4.732 0 0015.273 20 4.732 4.732 0 0020 15.273a4.732 4.732 0 00-4.727-4.726zm0 7.89a3.168 3.168 0 01-3.164-3.164 3.168 3.168 0 013.164-3.164 3.168 3.168 0 013.165 3.164 3.168 3.168 0 01-3.165 3.165z"}}),_c('path',{attrs:{"d":"M16.406 14.492h-.351v-.82a.781.781 0 00-1.563 0v1.601c0 .432.35.782.781.782h1.133a.781.781 0 000-1.563zM11.68 8.984a.781.781 0 100-1.562.781.781 0 000 1.562zM8.281 12.383a.781.781 0 100-1.563.781.781 0 000 1.563zM4.883 8.984a.781.781 0 100-1.562.781.781 0 000 1.562zM4.883 12.383a.781.781 0 100-1.563.781.781 0 000 1.563zM4.883 15.781a.781.781 0 100-1.562.781.781 0 000 1.562zM8.281 15.781a.781.781 0 100-1.562.781.781 0 000 1.562zM8.281 8.984a.781.781 0 100-1.562.781.781 0 000 1.562z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_160_487"}},[_c('path',{attrs:{"d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    